/**
 * @author AUTHOR_NAME
 * @email AUTHOR_EMAIL
 * @create date 
 * @modify date 
 * @desc All the environment variables are taken from process.env and exported 
 * via Config variable.
 */

import dotenv from "dotenv";
import { envdata } from "./utils/helperFunctions";
dotenv.config();

let Config = {};

let env = envdata();

Config.api_url = env?.REACT_APP_API_ENDPOINT;
Config.graphql = env?.REACT_APP_GQL_ENDPOINT;
Config.socket = env?.REACT_APP_SOCKET;

export default Config;
